import { Storage } from 'aws-amplify';

/**
 * Get a signed URL for a file in storage
 * @param key The key of the file
 * @returns Promise with the signed URL
 */
export const getSignedUrl = async (key: string): Promise<string> => {
  try {
    return await Storage.get(key, { level: 'private' });
  } catch (error) {
    console.error('Error getting signed URL:', error);
    return '';
  }
};
